export default {
  creditScorePage: {
    headerTitle: 'Credit tracking',
    titleText: 'Take control of your credit',
    button: 'See my score',
    freeCreditTrackingLabel: 'Free credit tracking',
    trackingYourScoreContent:
      'Tracking your score is the first step – and now you can do it directly from the Varo app. It’s 100% free and won’t impact your score.',
    instruction:
      'You understand that by clicking on the button above you are providing “written instructions” authorizing Varo to obtain information from your personal credit profile from TransUnion, at our discretion, to confirm your identity, display your credit data to you, and inform you of special promotions and targeted offers.',
    tryAgainButton: 'Try again',
    comeBackLaterButton: 'I’ll come back later',
  },
  aboutCreditScorePage: {
    navigationTitle: 'Credit score',
    aboutTitle: 'About your credit score',
    aboutDescription: `Below are the factors affecting your VantageScore® credit score from TransUnion®.`,
    understandTitle: 'Understanding your credit score',
    understandDescription: `We show you your VantageScore® 3.0 credit score. There are three major credit reporting agencies that each provide their own score, and TransUnion® is one of them. You’re entitled to a free credit report every year that has info from all three reporting agencies.`,
    helpTitle: 'Help',
    faqTitle: 'Credit score FAQs',
    disputeTitle: 'Contact Transunion Dispute Center',
  },
};
